import React from "react";
import CustomersDir from "./CustomersDir";

// Wrapper para reutilizar CustomersDir em modo "Arrematantes disponíveis"
export default function CustomersDirExpired() {
  return <CustomersDir expiredMode={true} />;
}

